import { render, staticRenderFns } from "./ClinicalDepartment.vue?vue&type=template&id=9dcf6bea&scoped=true"
import script from "./ClinicalDepartment.vue?vue&type=script&lang=js"
export * from "./ClinicalDepartment.vue?vue&type=script&lang=js"
import style0 from "./ClinicalDepartment.vue?vue&type=style&index=0&id=9dcf6bea&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dcf6bea",
  null
  
)

export default component.exports